import { components } from 'type/ReportServiceSchema';

export type TrendQuestionDto = components['schemas']['TrendQuestion'];

export type TrendQuestionModel = {
  askedAt: string;
  itemId: number;
};

export const mapTrendQuestionDtoToModel = (dto: TrendQuestionDto): TrendQuestionModel => ({
  askedAt: dto.askedAt,
  itemId: dto.itemId,
});
